import * as THREE from 'three';
import UIEventBus from '../UI/EventBus';
export class AudioSource {
    constructor(manager) {
        this.manager = manager;
    }
    update() { }
}
export class ComputerAudio extends AudioSource {
    constructor(manager) {
        super(manager);
        document.addEventListener('mousedown', (event) => {
            // @ts-ignore
            if (event.inComputer) {
                this.manager.playAudio('mouseDown', {
                    volume: 0.8,
                    position: new THREE.Vector3(800, -300, 1200),
                });
            }
        });
        document.addEventListener('mouseup', (event) => {
            // @ts-ignore
            if (event.inComputer) {
                this.manager.playAudio('mouseUp', {
                    volume: 0.8,
                    position: new THREE.Vector3(800, -300, 1200),
                });
            }
        });
        document.addEventListener('keyup', (event) => {
            // @ts-ignore
            if (event.inComputer) {
                this.lastKey = '';
            }
        });
        document.addEventListener('keydown', (event) => {
            if (this.lastKey === event.key)
                return;
            this.lastKey = event.key;
            // @ts-ignore
            if (event.inComputer) {
                this.manager.playAudio('keyboardKeydown', {
                    volume: 0.8,
                    position: new THREE.Vector3(-300, -400, 1200),
                });
            }
        });
    }
}
export class AmbienceAudio extends AudioSource {
    constructor(manager) {
        super(manager);
        UIEventBus.on('loadingScreenDone', () => {
            // Jouer uniquement le son de démarrage
            this.manager.playAudio('startup', {
                volume: 0.4,
                randDetuneScale: 0,
            });
        });
    }
    // Méthode simplifiée car nous n'avons plus de son d'ambiance
    update() {
        // Ne rien faire - les sons d'ambiance ont été supprimés
    }
}
